/** Canonical public web origin for share links and deep links. */
export const APP_WEB_ORIGIN = 'https://mahjong.siuheibo.com'
